export const MBS = {
  GET_USER_MEDIA_SUCCESS: "GET_USER_MEDIA_SUCCESS",
  GET_USER_MEDIA_FAILED: "GET_USER_MEDIA_FAILED",
  MEDIA_CONSTRAINS_SETTING_FRAME_RATE: "MEDIA_CONSTRAINS_SETTING_FRAME_RATE"
}
